<template>
  <div class="rentpress-shortcode-single-property-wrapper">
    <v-banner
      v-if="
        property.property_specials_message &&
          (!property.property_specials_expiration ||
            property.property_specials_expiration >= todaysDate)
      "
      elevation="8"
      :color="primaryColor"
      :style="{ color: getContrastingTextColor(primaryColor) }"
      class="rentpress-inherited-font-family text-h6 text-center rentpress-single-property-specials-banner"
      style="z-index: 1"
    >
      <div
        @click="
          navigateToExternalSite(property.property_specials_link);
          gtag('event', 'special_view_rentpress', {
            property_name: property.property_name,
            city: property.property_city
          });
        "
        :style="property.property_specials_link ? 'cursor:pointer;' : ''"
      >
        <div class="special-banner-content">
          <v-icon
            :style="{ color: getContrastingTextColor(primaryColor) }"
            class="property-special-icon"
            >{{ $vuetify.icons.values.star }}</v-icon
          >
          <span class="special-text-wrapper">
            <strong>SPECIAL:</strong>
            {{ property.property_specials_message }}
          </span>
        </div>
      </div>
    </v-banner>
    <!-- Featured Image row -->
    <v-row
      no-gutters
      align="center"
      class="rentpress-single-property-hero-section"
    >
      <v-col xl="9" lg="8" md="7" sm="12" class="d-flex hero-image-col">
        <v-img
          :src="featuredImage"
          :srcset="featuredImageSrcset"
          max-height="600px"
          class="rentpress-single-property-hero-image"
          @click="viewImageFullscreen(0)"
          style="cursor: zoom-in;"
        ></v-img>
        <template v-slot:placeholder>
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular
              :color="parentPropertyColor ? parentPropertyColor : 'primary'"
              indeterminate
            ></v-progress-circular>
          </div>
        </template>
      </v-col>
      <v-col
        xl="3"
        lg="4"
        md="5"
        sm="12"
        class="text-left px-2 rentpress-single-property-hero-info"
      >
        <v-list-item>
          <v-list-item-content>
            <h1
              class="rentpress-inherited-font-family secondary--text text-wrap text-h4 rentpress-single-property-title"
              v-html="property.property_name"
            ></h1>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="rentpress-inherited-font-family">
          <v-list-item-content>
            <v-list-item-title
              class="rentpress-inherited-font-family text-subtitle-2 font-weight-bold rentpress-single-property-hero-section-address"
            >
              {{ property.property_neighborhood_post_name }}
            </v-list-item-title>
            <v-list-item-title
              class="rentpress-inherited-font-family text-subtitle-1 rentpress-single-property-hero-section-address"
            >
              {{ property.property_address }}
            </v-list-item-title>
            <v-list-item-title
              class="rentpress-inherited-font-family text-subtitle-1 rentpress-single-property-hero-section-address"
            >
              {{ property.property_city }}, {{ property.property_state }}
              {{ property.property_zip }}
            </v-list-item-title>
            <v-list-item-title
              class="rentpress-inherited-font-family text-subtitle-1 pa-0 ma-0"
            >
              <v-btn
                color="secondary"
                small
                tile
                text
                class="rentpress-single-property-hero-address-link pl-1"
                @click="
                  navigateToExternalSite(directionsAddress);
                  gtag('event', 'directions_click_rentpress', {
                    property_name: property.property_name,
                    city: property.property_city
                  });
                "
              >
                <v-icon left small>{{ $vuetify.icons.values.map }}</v-icon>
                Directions
              </v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          class="rentpress-inherited-font-family text-subtitle-1 rentpress-single-property-hero-sub-info"
        >
          <v-list-item-content>
            <v-list-item-title
              class="rentpress-inherited-font-family text-subtitle-1 rentpress-single-property-hero-beds-price-range"
            >
              {{ displayBedroomRange }}
              <span
                v-if="
                  !disablePrice &&
                    property.property_rent_type_selection ==
                      'Minimum - Maximum' &&
                    property.property_rent_min &&
                    property.property_rent_min > 100 &&
                    property.property_rent_max &&
                    property.property_rent_max > 100 &&
                    property.property_rent_min != property.property_rent_max
                "
              >
                |
                {{ formatter.format(property.property_rent_min) }} -
                {{ formatter.format(property.property_rent_max) }}
              </span>
              <span
                v-else-if="
                  !disablePrice &&
                    property.property_rent_type_selection_cost &&
                    property.property_rent_type_selection_cost > 100
                "
              >
                | Starting at
                {{
                  formatter.format(property.property_rent_type_selection_cost)
                }}
              </span>
              <span
                v-else-if="
                  options.rentpress_disable_pricing_section_disable_pricing_message &&
                    options.rentpress_disable_pricing_section_disable_pricing_message !==
                      ''
                "
              >
                |
                {{
                  options.rentpress_disable_pricing_section_disable_pricing_message
                }}
              </span>
            </v-list-item-title>
            <v-list-item-title
              class="rentpress-inherited-font-family text-subtitle-1 rentpress-single-property-hero-pets-info pb-4"
            >
              {{ displayPetText }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-row class="rentpress-single-property-hero-contact-links pb-3">
          <v-col
            v-if="property.property_phone_number"
            cols="5"
            class="d-flex justify-center align-center"
          >
            <v-btn
              color="secondary"
              small
              tile
              text
              class="rentpress-single-property-hero-phone"
              @click="
                dial(property.property_phone_number);
                gtag('event', 'phonecall_click_rentpress', {
                  property_name: property.property_name,
                  city: property.property_city
                });
              "
            >
              <v-icon left small>{{ $vuetify.icons.values.cellphone }}</v-icon>
              {{ displayPhoneNumber }}
            </v-btn>
          </v-col>
          <v-col v-if="property.property_email" class="mr-2" cols="3">
            <v-btn
              color="secondary"
              small
              tile
              text
              class="rentpress-single-property-hero-email"
              @click="
                sendMail(property.property_email);
                gtag('event', 'emailus_click_rentpress', {
                  property_name: property.property_name,
                  city: property.property_city
                });
              "
            >
              <v-icon left small>{{ $vuetify.icons.values.email }}</v-icon>
              Email Us
            </v-btn>
          </v-col>
          <v-col v-if="property.property_website" cols="3">
            <v-btn
              color="secondary"
              small
              tile
              text
              class="rentpress-single-property-hero-website"
              @click="
                navigateToExternalSite(property.property_website);
                gtag('event', 'visitpropertywebsite_click_rentpress', {
                  property_name: property.property_name,
                  city: property.property_city
                });
              "
            >
              <v-icon left small>{{ $vuetify.icons.values.web }}</v-icon>
              Website
            </v-btn>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col
            v-if="
              this.options.rentpress_application_link_section_url_tour != ''
            "
            cols="12"
            class="rentpress-single-property-hero-button-tour"
          >
            <v-btn
              block
              elevation="4"
              :color="primaryColor"
              :style="{
                color: getContrastingTextColor(primaryColor)
              }"
              large
              @click="
                navigateTo(tourLink);
                gtag('event', 'scheduletour_click_rentpress', {
                  property_name: property.property_name,
                  city: property.property_city
                });
              "
              class="rentpress-application-link-section-url-tour-button"
              >Schedule Tour</v-btn
            >
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="6">
            <div v-if="property.property_contact_type == '3'">
              <v-btn
                block
                class="rentpress-single-property-hero-button-contact"
                :color="primaryColor"
                :style="{
                  color: getContrastingTextColor(primaryColor)
                }"
                large
                :outlined="
                  this.options.rentpress_application_link_section_url_tour != ''
                "
                @click="
                  openGravityFormsModal(property.property_post_id);
                  gtag('event', 'contactleasing_click_rentpress', {
                    property_name: property.property_name,
                    city: property.property_city
                  });
                "
              >
                Contact Leasing
              </v-btn>
              <v-dialog
                v-if="propertyGravityForm"
                v-model="propertyGravityForm"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                scrollable
                class="rentpress-form-dialog"
              >
                <v-card tile>
                  <v-btn
                    :color="primaryColor"
                    :style="{
                      color: getContrastingTextColor(primaryColor),
                      '--primary-color': primaryColor
                    }"
                    fab
                    small
                    absolute
                    top
                    right
                    @click="propertyGravityForm = ''"
                    class="mt-6 mr-n3 rentpress-form-close-button"
                    elevation="10"
                  >
                    <v-icon>{{ $vuetify.icons.values.close }}</v-icon>
                  </v-btn>
                  <div
                    class="floorplan-form-pop-up"
                    v-html="floorplanForm"
                    ref="gravityform"
                  ></div>
                </v-card>
              </v-dialog>
            </div>
            <div v-else>
              <v-btn
                block
                class="rentpress-single-property-hero-button-contact"
                :color="primaryColor"
                :style="
                  getOutlinedButtonStyle(
                    primaryColor,
                    options.rentpress_application_link_section_url_tour != ''
                  )
                "
                :outlined="
                  options.rentpress_application_link_section_url_tour != ''
                "
                large
                @click="
                  navigateTo(contactLink);
                  gtag('event', 'contactleasing_click_rentpress', {
                    property_name: property.property_name,
                    city: property.property_city
                  });
                "
              >
                Contact Leasing
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="applyLink" xl="6" lg="6" md="6" sm="6">
            <v-btn
              class="rentpress-single-property-hero-button-apply"
              :color="primaryColor"
              block
              large
              outlined
              :href="applyLink"
              :target="
                options.rentpress_apply_link_section === 'New Window'
                  ? '_blank'
                  : '_self'
              "
              :style="getOutlinedButtonStyle(primaryColor, true)"
              @click="
                gtag('event', 'applynow_click_rentpress', {
                  property_name: property.property_name,
                  city: property.property_city
                })
              "
            >
              Apply Now
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          v-if="
            property.property_facebook_link ||
              property.property_instagram_link ||
              property.property_residents_link
          "
          class="rentpress-single-property-hero-social-residents"
        >
          <v-col cols="auto">
            <p
              class="rentpress-inherited-font-family font-weight-bold secondary--text pt-1 rentpress-single-property-hero-social-profile-group"
            >
              FIND US
            </p>
          </v-col>
          <v-col cols="auto">
            <v-btn
              v-if="property.property_facebook_link"
              icon
              class="rentpress-single-property-hero-social-profile-facebook"
              @click="navigateToExternalSite(property.property_facebook_link)"
            >
              <v-icon class="white--text secondary">{{
                $vuetify.icons.values.facebook
              }}</v-icon>
            </v-btn>
            <v-btn
              v-if="property.property_instagram_link"
              icon
              class="rentpress-single-property-hero-social-profile-instagram"
              @click="navigateToExternalSite(property.property_instagram_link)"
            >
              <v-icon class="white--text secondary">{{
                $vuetify.icons.values.instagram
              }}</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col v-if="property.property_residents_link">
            <v-btn
              text
              class="rentpress-single-property-hero-residents"
              @click="navigateToExternalSite(property.property_residents_link)"
            >
              <v-icon left small>{{
                $vuetify.icons.values.arrowRightCircle
              }}</v-icon>
              Residents Portal
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- End of featured Image row -->
    <div
      class="text-center rentpress--on-page-nav rentpress-single-property-subnav"
      :style="{
        color: getContrastingTextColor(primaryColor),
        backgroundColor: primaryColor,
        overflowX: 'auto',
        whiteSpace: 'nowrap'
      }"
    >
      <v-btn
        v-if="showPropertyInfo"
        text
        :style="{
          color: getContrastingTextColor(primaryColor)
        }"
        class="font-weight-bold rentpress--on-page-nav--link rentpress-single-property-subnav-amenities"
        @click="$vuetify.goTo('#amenities', scrollOptions)"
      >
        About
      </v-btn>
      <v-btn
        v-if="hasFloorplans"
        text
        :style="{
          color: getContrastingTextColor(primaryColor)
        }"
        class="font-weight-bold rentpress--on-page-nav--link rentpress-single-property-subnav-floorplans"
        @click="$vuetify.goTo('#floorplans', scrollOptions)"
      >
        Floor Plans
      </v-btn>
      <v-btn
        v-if="!hideNeighborhood"
        text
        :style="{
          color: getContrastingTextColor(primaryColor)
        }"
        class="font-weight-bold rentpress--on-page-nav--link rentpress-single-property-subnav-location"
        @click="$vuetify.goTo('#neighborhood', scrollOptions)"
      >
        Neighborhood
      </v-btn>
      <v-btn
        v-if="
          (galleryImages && galleryImages.length > 0) || hasGalleryShortcode
        "
        text
        :style="{
          color: getContrastingTextColor(primaryColor)
        }"
        class="font-weight-bold rentpress--on-page-nav--link rentpress-single-property-subnav-gallery"
        @click="$vuetify.goTo('#gallery', scrollOptions)"
      >
        Gallery
      </v-btn>
    </div>
    <v-card
      class="rentpress-single-property-info-row border-0"
      color="#F9F9F9"
      tile
      flat
      v-if="showPropertyInfo"
    >
      <v-container fluid>
        <v-row
          tile
          class="text-left rentpress-shortcode-single-property-page-row border-0"
          justify="center"
        >
          <!-- Description -->
          <v-col
            v-if="property.property_description"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            cols="auto"
          >
            <v-list-item>
              <v-list-item-content>
                <h3
                  class="rentpress-inherited-font-family text-h5 secondary--text rentpress-single-property-about-title"
                >
                  About Our Community
                </h3>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <p
                  class="rentpress-inherited-font-family text-wrap text-body-1 rentpress-property-about-section"
                  v-html="property.property_description"
                ></p>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <!-- Amenities -->
          <v-col
            v-if="amenitiesList.length > 0"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            cols="12"
            class="rentpress-single-property-amenities-wrapper"
          >
            <v-list-item>
              <v-list-item-content>
                <h3
                  class="rentpress-inherited-font-family text-h5 secondary--text rentpress-single-property-amenities-title"
                >
                  Amenities
                </h3>
              </v-list-item-content>
            </v-list-item>
            <v-row no-gutters justify="space-between">
              <v-col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                cols="12"
                id="property_amenities"
              >
                <div
                  v-for="(amenity, index) in amenitiesList"
                  :key="index"
                  class="rentpress-inherited-font-family text-body-2 pb-2"
                >
                  <v-icon class="primary--text">{{
                    $vuetify.icons.values.next
                  }}</v-icon>
                  {{ amenity }}
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- Features -->
          <v-col
            v-if="propertyFeaturesExcludingFloorplans.length > 0"
            xl="12"
            lg="12"
            md="12"
            sm="12"
            cols="12"
          >
            <v-list-item>
              <v-list-item-content>
                <h3
                  class="rentpress-inherited-font-family text-h5 secondary--text"
                >
                  Features
                </h3>
              </v-list-item-content>
            </v-list-item>
            <v-row no-gutters justify="space-between">
              <v-col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                cols="auto"
                id="property_features"
              >
                <div
                  v-for="(feature,
                  index) in propertyFeaturesExcludingFloorplans"
                  :key="index"
                  class="rentpress-inherited-font-family text-body-2 pb-2"
                >
                  <v-icon class="primary--text">{{
                    $vuetify.icons.values.next
                  }}</v-icon>
                  {{ feature }}
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- Pet Policy -->
          <v-col
            class="text-left rentpress-pet-policy-container"
            v-if="property.property_pet_policy"
            xl="8"
            lg="8"
            md="12"
            sm="12"
            cols="auto"
            id="property-pet-policy"
          >
            <v-list-item>
              <v-list-item-content>
                <h3
                  class="rentpress-inherited-font-family text-h5 secondary--text"
                >
                  {{ property.property_name + " Pet Policy" }}
                </h3>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  class="rentpress-inherited-font-family text-wrap text-body-1 pre-formatted"
                  v-html="property.property_pet_policy"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <!-- Office Hours -->
          <v-col
            v-if="hasOfficeHours"
            class="rentpress-office-hours-container"
            xl="4"
            lg="4"
            md="12"
            sm="12"
            cols="12"
          >
            <v-list-item class="rentpress-office-hours-title">
              <v-list-item-content>
                <h3
                  class="rentpress-inherited-font-family text-h5 secondary--text"
                >
                  Office Hours
                </h3>
              </v-list-item-content>
            </v-list-item>
            <ul class="rentpress-office-hours-list">
              <li v-for="(officeHour, day) in officeHours" :key="day">
                <span
                  v-if="officeHour"
                  class="rentpress-inherited-font-family text-body-2"
                  :class="today == day ? 'font-weight-black' : ''"
                >
                  <v-icon class="primary--text">{{
                    $vuetify.icons.values.next
                  }}</v-icon>
                  {{ day }}: <span v-html="officeHour"></span>
                </span>
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <div v-if="hasFloorplans" id="floorplans" class="ma-3">
      <v-row justify="center" class="my-5">
        <v-col cols="auto">
          <h3
            class="rentpress-inherited-font-family secondary--text text-h5 rentpress-single-property-floorplan-section-title"
            v-html="property.property_name + ' Floor Plans'"
          ></h3>
        </v-col>
      </v-row>
      <v-lazy
        :min-height="200"
        :options="{ threshold: 0.5 }"
        transition="fade-transition"
      >
        <floorplan-search
          v-if="
            floorplansWithPropertyData[0] &&
              floorplansWithPropertyData[0].floorplan_code
          "
          :floorplans="floorplansWithPropertyData"
          :parentproperties="[property]"
          :options="options"
          :useModals="useModals || hasGravityForm"
          :formatter="formatter"
          :sidebarFilters="true"
          :useEngrain="true"
        />
      </v-lazy>
    </div>

    <div id="neighborhood" v-if="!hideNeighborhood">
      <v-lazy
        :min-height="400"
        :options="{ threshold: 0.5 }"
        transition="fade-transition"
      >
        <v-row
          v-if="neighborhoodData.post"
          no-gutters
          align="center"
          justify="center"
          class="rentpress-single-property-location-row"
        >
          <v-col
            v-if="showMap"
            xl="9"
            lg="8"
            md="12"
            sm="12"
            cols="12"
            class="rentpress-single-property-location-map"
          >
            <slot name="map" />
          </v-col>
          <v-col
            v-else
            xl="9"
            lg="8"
            md="12"
            sm="12"
            cols="12"
            class="rentpress-single-property-location-image"
          >
            <v-lazy
              v-model="isActive"
              :min-height="200"
              :options="{ threshold: 0.5 }"
              transition="fade-transition"
            >
              <v-img
                :src="neighborhoodData.image_src || cityPlaceholderImage"
                :srcset="neighborhoodData.image_srcset"
                height="500"
                cover
              ></v-img>
            </v-lazy>
          </v-col>
          <v-col
            xl="3"
            lg="4"
            md="12"
            sm="12"
            cols="12"
            class="rentpress-inherited-font-family text-left rentpress-single-property-location-text px-6 px-lg-4"
          >
            <p
              class="rentpress-inherited-font-family text-subtitle-1 mt-4 rentpress-single-property-location-property-name"
            >
              {{ property.property_name }}
            </p>
            <p
              class="rentpress-inherited-font-family text-h4 rentpress-single-property-location-neighborhood-title"
            >
              {{ neighborhoodData.post.post_title }}
            </p>
            <p
              v-if="
                neighborhoodData.rentpress_custom_field_neighborhood_romance_copy &&
                  neighborhoodData
                    .rentpress_custom_field_neighborhood_romance_copy[0]
              "
              class="rentpress-inherited-font-family rentpress-single-property-location-romance-copy"
            >
              {{
                neighborhoodData
                  .rentpress_custom_field_neighborhood_romance_copy[0]
              }}
            </p>
            <v-btn
              class="rentpress-single-property-location-button"
              block
              elevation="4"
              :color="primaryColor"
              :style="{
                color: getContrastingTextColor(primaryColor)
              }"
              large
              :href="neighborhoodData.post.post_link"
              @click="
                gtag('event', 'learnmore_click_rentpress', {
                  property_name: property.property_name,
                  city: property.property_city
                })
              "
            >
              Learn More
            </v-btn>
          </v-col>
        </v-row>
      </v-lazy>
    </div>

    <div
      v-if="(galleryImages && galleryImages.length > 0) || hasGalleryShortcode"
      id="gallery"
    >
      <v-row align="center" justify="center">
        <v-col cols="auto">
          <p
            class="rentpress-inherited-font-family secondary--text text-center text-subtitle-1 rentpress-single-property-gallery-title"
          >
            Take A Look Around
          </p>
          <h3
            class="rentpress-inherited-font-family text-center text-h5 rentpress-single-property-gallery-title"
          >
            {{ property.property_name }} Photos
          </h3>
        </v-col>
      </v-row>
      <v-lazy
        :min-height="200"
        :options="{ threshold: 0.5 }"
        transition="fade-transition"
      >
        <v-row justify="center" class="mx-1">
          <v-col
            v-for="(galleryImage, imageKey) in galleryImages"
            :key="'galleryImage' + imageKey"
            class="d-flex child-flex pa-1 rentpress-single-property-gallery"
            cols="auto"
            sm="4"
            md="3"
            lg="3"
            xl="2"
          >
            <v-img
              min-height="150px"
              :max-height="$vuetify.breakpoint.xs ? '150px' : '400px'"
              min-width="150px"
              class="rentpress-single-property-gallery-image"
              :alt="getGalleryAlt(galleryImage)"
              :src="galleryImage.sizes?.medium?.url || galleryImage.url"
              aspect-ratio="1"
              @click="viewImageFullscreen(imageKey)"
            />
          </v-col>
          <v-col
            v-for="(galleryImage, imageKey) in galleryImages"
            :key="imageKey"
            class="d-flex d-sm-none child-flex pa-1"
            cols="auto"
          >
            <v-img
              min-height="150px"
              max-height="150px"
              min-width="150px"
              class="rentpress-single-property-gallery-image-thumnail"
              :src="galleryImage.sizes?.medium?.url || galleryImage.url"
              aspect-ratio="1"
              @click="viewImageFullscreen(imageKey)"
            />
          </v-col>
        </v-row>
      </v-lazy>
      <v-overlay
        v-if="galleryOverlay"
        z-index="999999"
        :value="galleryOverlay"
        opacity="0.85"
        class="rentpress-single-property-gallery-lightbox"
        v-touch="{
          left: () => gallerySwipe('Left'),
          right: () => gallerySwipe('Right'),
          up: () => gallerySwipe('Up'),
          down: () => gallerySwipe('Down')
        }"
        @keydown.native.esc="galleryOverlay = false"
        @keydown.native.left="gallerySwipe('Left')"
        @keydown.native.right="gallerySwipe('Right')"
        tabindex="0"
      >
        <div
          class="rentpress-gallery-backdrop"
          style="position:absolute; inset:0; z-index:1;"
          @click="galleryOverlay = false"
        ></div>
        <div
          ref="galleryWrapper"
          style="position: relative; z-index: 2;"
          tabindex="-1"
        >
          <v-carousel v-model="selectedGalleryImage" height="100vh">
            <v-carousel-item
              v-for="(galleryImage, galleryImageKey) in galleryImages"
              :key="galleryImageKey"
              class="rentpress-single-property-gallery-carousel-item"
            >
              <v-sheet
                @click.self="galleryOverlay = false"
                color="transparent"
                height="100vh"
                width="100vw"
                tile
              >
                <v-row class="fill-height" align="center" justify="center">
                  <v-img
                    class="gallery-lightbox-image"
                    max-height="95vh"
                    max-width="95vw"
                    :alt="getGalleryAlt(galleryImage)"
                    :height="galleryImage.height"
                    :src="galleryImage.url"
                    contain
                    @click.stop="handleImageClick"
                  />
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
          <v-btn
            @click="galleryOverlay = false"
            fab
            top
            right
            tonal
            large
            absolute
            z-index="999994"
            class="mt-12 rentpress-gallery-close-button"
            :color="primaryColor"
            style="filter: drop-shadow(1px 1px 10px #dedede4d);"
            :style="{
              color: getContrastingTextColor(primaryColor)
            }"
          >
            <v-icon x-large>{{ $vuetify.icons.values.close }}</v-icon>
          </v-btn>
        </div>
      </v-overlay>
    </div>

    <div
      v-if="properties.length > 0"
      id="related-properties"
      class="related-properties-section"
    >
      <v-row justify="center" class="mt-10">
        <v-col cols="auto" class="pa-0">
          <p
            class="rentpress-inherited-font-family secondary--text rentpress-single-property-related-title pa-0 mb-2"
          >
            Looking For Something Else?
          </p>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="rentpress-single-property-related-subtitle pa-0"
      >
        <v-col cols="auto" class="pa-0">
          <h3 class="rentpress-inherited-font-family secondary--text text-h5">
            Explore Other Options
          </h3>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="rentpress-single-property-related-subtitle mb-8"
      >
        <v-col
          v-for="property in properties"
          :key="property.property_code"
          cols="12"
          sm="6"
          md="4"
          class="d-flex justify-center"
        >
          <property-card
            :property="property"
            :options="options"
            :formatter="formatter"
            class="rentpress-property-card related-property-card"
          />
        </v-col>
      </v-row>
    </div>
    <script v-html="jsonld" type="application/ld+json"></script>
  </div>
</template>

<script>
export default {
  name: "single-property-page",
  data() {
    return {
      galleryOverlay: false,
      selectedGalleryImage: 0,
      cityPlaceholderImage: this.options.rentpress_default_city_image_section,
      propertyGravityForm: "",
      scrollOptions: Object.freeze({
        easing: "easeInQuad",
        duration: 1000,
        offset: 0
      }),
      propertyPrimaryStyle: {
        backgroundColor: this.options.rentpress_accent_color_section_input,
        borderColor: this.options.rentpress_accent_color_section_input
      },
      disablePrice: this.options
        .rentpress_disable_pricing_section_disable_pricing
    };
  },
  props: {
    property: Object,
    properties: Array,
    options: {
      type: Object,
      default: () => ({})
    },
    city: Object,
    neighborhood: Object,
    hideNeighborhood: Boolean,
    hasGalleryShortcode: Boolean,
    formatter: Intl.NumberFormat,
    useModals: {
      type: Boolean,
      default: true
    },
    showMap: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    jsonld() {
      return Object.freeze({
        "@type": "ItemPage",
        primaryImageOfPage: this.property.property_featured_image_src,
        significantLink: this.property.property_availability_url,
        keywords: this.property.property_additional_keywords,
        about: {
          "@type": "Product",
          image: this.property.property_featured_image_src,
          description: this.property.property_description,
          brand: this.options.site_name,
          offers: {
            "@type": "aggregateOffer",
            lowPrice: this.property.property_rent_min,
            highPrice: this.property.property_rent_max,
            priceCurrency: "USD",
            offerCount: this.property.property_floorplan_count
          },
          sku: this.property.property_code,
          name: this.property.property_name,
          sameAs: [
            this.property.property_website,
            this.property.property_facebook_link,
            this.property.property_instagram_link
          ]
        },
        breadcrumb: {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: this.options.site_name + " Home",
              item: this.options.site_url
            },
            {
              "@type": "ListItem",
              position: 2,
              name: this.property.property_city,
              item:
                this.options.site_url + "/city/" + this.property.property_city
            },
            {
              "@type": "ListItem",
              position: 3,
              name: this.property.property_name,
              item: this.property.property_post_link
            }
          ]
        },
        mainEntity: [
          {
            url: this.property.property_post_link,
            telephone: this.property.property_phone_number,
            description: this.property.property_description,
            address: {
              "@type": "PostalAddress",
              streetAddress: this.property.property_address,
              addressLocality: this.property.property_city,
              addressRegion: this.property.property_state,
              postalCode: this.property.property_zip
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: this.property.property_latitude,
              longitude: this.property.property_longitude
            },
            image: [this.property.property_featured_image_src],
            containsPlace: {
              "@type": "Apartment",
              petsAllowed: this.displayPetText
            },
            containedInPlace: {
              "@type": "LocalBusiness",
              pricerange:
                "$" +
                this.property.property_rent_min +
                " - $" +
                this.property.property_rent_max,
              telephone: this.property.property_phone_number,
              image: this.property.property_featured_image_src,
              address: {
                "@type": "PostalAddress",
                streetAddress: this.property.property_address,
                addressLocality: this.property.property_city,
                addressRegion: this.property.property_state,
                postalCode: this.property.property_zip
              },
              openingHours: this.property.property_office_hours, //help
              name: this.property.property_name,
              "@id": this.property.property_post_link
            },
            "@type": "ApartmentComplex",
            name: this.property.property_name,
            tourBookingPage: this.property.property_tour_url,
            hasMap:
              "https://maps.google.com/maps?daddr=" +
              this.property.property_name +
              "+" +
              this.property.property_address +
              "+" +
              this.property.property_city +
              "+" +
              this.property.property_state,
            numberOfAvailableAccommodationUnits: this.property
              .property_available_floorplans,
            amenityFeature: this.property.property_terms,
            "@id": this.property.property_post_link
          }
        ],
        "@context": "http://schema.org"
      });
    },
    hasFloorplans() {
      return this.property.floorplans && this.property.floorplans.length > 0;
    },
    floorplansWithPropertyData() {
      if (!this.hasFloorplans) return [];
      // If already processed (has property_code), return as is
      if (this.property.floorplans[0].property_code !== undefined) {
        return this.property.floorplans;
      }
      const property = this.property;
      return this.property.floorplans.map(fp => {
        const newFp = { ...property, ...fp };
        delete newFp.floorplans;
        return newFp;
      });
    },
    amenitiesList() {
      if (this.property.property_community_amenities) {
        try {
          return JSON.parse(this.property.property_community_amenities);
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    featuresList() {
      return this.propertyFeaturesExcludingFloorplans;
    },
    hasGravityForm() {
      return this.property.property_contact_type == "3";
    },
    floorplanForm() {
      const contactType = this.property.property_contact_type;
      const formEl = document.getElementById(
        this.property.property_code + "_form_wrapper"
      );
      if (formEl && contactType && contactType !== "Global Setting") {
        return formEl.innerHTML;
      }
      return "";
    },
    contactLink() {
      const contactLink = this.property.property_contact_link;
      const contactType = this.property.property_contact_type;
      const applicationLink =
        this.options?.rentpress_application_link_section_url_contact || "";
      const baseURL =
        contactLink !== "" &&
        contactLink !== null &&
        contactType !== "Global Setting"
          ? contactLink
          : applicationLink;
      return (
        baseURL +
        "?property_code=" +
        this.property.property_code +
        "&property_name=" +
        this.property.property_name
      );
    },
    tourLink() {
      return (
        this.options.rentpress_application_link_section_url_tour +
        "?property_code=" +
        this.property.property_code +
        "&property_name=" +
        this.property.property_name
      );
    },
    applyLink() {
      return (
        this.property.property_availability_url ??
        this.options.rentpress_application_link_section_default_application_url
      );
    },
    hasOfficeHours() {
      return !!(
        this.officeHours.Monday !== "" ||
        this.officeHours.Tuesday !== "" ||
        this.officeHours.Wednesday !== "" ||
        this.officeHours.Thursday !== "" ||
        this.officeHours.Friday !== "" ||
        this.officeHours.Saturday !== "" ||
        this.officeHours.Sunday !== ""
      );
    },
    showPropertyInfo() {
      return (
        this.property.property_description ||
        this.amenitiesList.length > 0 ||
        this.featuresList.length > 0 ||
        this.property.property_pet_policy ||
        this.hasOfficeHours
      );
    },
    primaryColor() {
      return Number(this.property.property_use_accent_color) === 1
        ? this.property.property_accent_color
        : this.options.rentpress_accent_color_section_input || "primary";
    },
    galleryImages() {
      // Always include featured image first, then gallery images (if any)
      const images = [];
      if (
        this.property &&
        this.property.property_featured_image_src &&
        this.property.property_featured_image_src !== ""
      ) {
        images.push({ url: this.property.property_featured_image_src });
      }
      let gallery = [];
      if (
        this.property &&
        this.property.property_gallery_images &&
        this.property.property_gallery_images !== ""
      ) {
        try {
          gallery = JSON.parse(this.property.property_gallery_images);
        } catch (e) {
          gallery = [];
        }
      }
      // Only add gallery images that are not the featured image
      return images.concat(gallery);
    },
    today() {
      return new Date().toLocaleDateString("en-US", { weekday: "long" });
    },
    todaysDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    propertyFeaturesExcludingFloorplans() {
      const property = this.property;

      // Parse property_features once and cache
      let propertyFeatures = [];
      if (property.property_features) {
        try {
          propertyFeatures =
            typeof property.property_features === "string"
              ? JSON.parse(property.property_features)
              : property.property_features;
        } catch {
          propertyFeatures = [];
        }
      }

      // Pre-build a set of all floorplan features
      let floorplanFeaturesSet = property._cachedFloorplanFeatures;
      if (!floorplanFeaturesSet) {
        floorplanFeaturesSet = new Set();
        if (property.floorplans && property.floorplans.length > 0) {
          property.floorplans.forEach(fp => {
            if (!fp.floorplan_features) return;
            try {
              const fpFeatures =
                typeof fp.floorplan_features === "string"
                  ? JSON.parse(fp.floorplan_features)
                  : fp.floorplan_features;
              fpFeatures.forEach(f => floorplanFeaturesSet.add(f));
            } catch {
              // skip invalid
            }
          });
        }
        // Cache on property object to avoid recomputing
        property._cachedFloorplanFeatures = floorplanFeaturesSet;
      }

      // Filter property_features not in any floorplan
      return propertyFeatures.filter(f => !floorplanFeaturesSet.has(f));
    },
    directionsAddress() {
      return (
        "https://maps.google.com/maps?daddr=" +
        this.property.property_name +
        "+" +
        this.property.property_address +
        "+" +
        this.property.property_city +
        "+" +
        this.property.property_state
      );
    },
    displayBedroomRange() {
      var displayBedroomRange = "";
      var bedTypes = this.property.property_bed_types
        .replace(/[^0-9]/g, "")
        .split("");

      if (bedTypes[0] && bedTypes[0] == 0) {
        displayBedroomRange = "Studio";
      } else if (bedTypes[0]) {
        displayBedroomRange = bedTypes[0] + " Bed";
      }

      if (bedTypes.length > 1) {
        displayBedroomRange += " - " + bedTypes[bedTypes.length - 1] + " Bed";
      }

      return displayBedroomRange;
    },
    displayPetText() {
      var displayPetText = "";
      let termStr = this.property.property_terms;
      const catRE = /\b[cC]+[aA]+[tT]+[sS]?\b/;
      const dogRE = /\b[dD]+[oO]+[gG]+[sS]?\b/;

      if (
        termStr &&
        catRE.exec(termStr) !== null &&
        dogRE.exec(termStr) !== null
      ) {
        displayPetText = "Cat and Dog Friendly";
      } else if (termStr && catRE.exec(termStr) !== null) {
        displayPetText = "Cat Friendly";
      } else if (termStr && dogRE.exec(termStr) !== null) {
        displayPetText = "Dog Friendly";
      }

      return displayPetText;
    },
    displayPhoneNumber() {
      let displayNumber = "";

      if (this.property.property_phone_number) {
        let phoneFormat = this.options.rentpress_format_phone_numbers_section_formatted_number.split(
          ""
        );
        let phone = this.property.property_phone_number.replace(/[^0-9]/g, "");
        let phoneIndex = 0;

        for (
          let formatIndex = 0;
          formatIndex < phoneFormat.length;
          formatIndex++
        ) {
          if (phoneFormat[formatIndex] == "x") {
            displayNumber += phone[phoneIndex];
            phoneIndex++;
          } else {
            displayNumber += phoneFormat[formatIndex];
          }
        }
      }
      return displayNumber;
    },
    featuredImage() {
      return this.property.property_featured_image_src &&
        this.property.property_featured_image_src != ""
        ? this.property.property_featured_image_src
        : this.options.rentpress_default_property_image_section;
    },
    featuredImageSrcset() {
      return this.property.property_featured_image_srcset &&
        this.property.property_featured_image_srcset != ""
        ? this.property.property_featured_image_srcset
        : this.options.rentpress_default_property_image_section;
    },
    officeHours() {
      let officeHours = this.property.property_office_hours
        ? JSON.parse(this.property.property_office_hours)
        : "";
      let officeHoursStringsArray = {
        Monday: "",
        Tuesday: "",
        Wednesday: "",
        Thursday: "",
        Friday: "",
        Saturday: "",
        Sunday: ""
      };
      for (const [day, hour] of Object.entries(officeHours)) {
        let officeHoursString = "";
        if (hour.status === "replace") {
          officeHoursString += hour.append_text != null ? hour.append_text : "";
          officeHoursStringsArray[day] = officeHoursString;
          continue;
        }
        if (hour.status === "appointment") {
          officeHoursString += "By Appointment ";
        }
        if (hour.status === "closed") {
          officeHoursString += "Closed ";
        }
        if (
          hour.open != null &&
          hour.open &&
          hour.status !== "closed" &&
          hour.status !== "appointment"
        ) {
          officeHoursString += hour.open;
          if (hour.close != null && hour.close) {
            officeHoursString += " - " + hour.close;
          }
        }
        if (hour.append === "on" && hour.append_text) {
          officeHoursString += " " + hour.append_text;
        }
        officeHoursStringsArray[day] = officeHoursString;
      }
      return officeHoursStringsArray;
    },
    neighborhoodData() {
      const source =
        this.property.property_primary_neighborhood_post_id &&
        this.neighborhood?.post
          ? this.neighborhood
          : this.city || {};

      return {
        post: source.post || {
          post_title: this.property.property_city,
          post_link: "#",
          guid: "#"
        },
        rentpress_custom_field_neighborhood_romance_copy: Array.isArray(
          source.rentpress_custom_field_neighborhood_romance_copy
        )
          ? source.rentpress_custom_field_neighborhood_romance_copy
          : [source.rentpress_custom_field_neighborhood_romance_copy || ""],
        image_src: source.image_src || this.cityPlaceholderImage,
        image_srcset: source.image_srcset || null
      };
    }
  },
  methods: {
    onGalleryKeydown(e) {
      // Left/right arrow navigation
      if (e.key === "ArrowLeft") {
        this.gallerySwipe("Left");
      } else if (e.key === "ArrowRight") {
        this.gallerySwipe("Right");
      }
    },
    openGravityFormsModal(id) {
      this.propertyGravityForm = id;
    },

    gallerySwipe(direction) {
      if (direction === "Right") {
        if (this.selectedGalleryImage < this.galleryImages.length - 1) {
          this.selectedGalleryImage++;
        } else {
          this.selectedGalleryImage = 0;
        }
      }
      if (direction === "Left") {
        if (this.selectedGalleryImage > 0) {
          this.selectedGalleryImage--;
        } else {
          this.selectedGalleryImage = this.galleryImages.length - 1;
        }
      }
      if (direction === "Down") {
        this.galleryOverlay = false;
      }
    },
    viewImageFullscreen(key) {
      this.selectedGalleryImage = key;
      this.galleryOverlay = true;
      this.$nextTick(() => {
        if (this.$refs.galleryWrapper) {
          this.$refs.galleryWrapper.focus();
        }
      });
    },
    handleImageClick() {
      // Clicking the image keeps the overlay open (no-op except ensure open)
      this.galleryOverlay = true;
    },
    navigateToExternalSite(newLocation) {
      // exit out of function if no link, this only happens with banner link, if in the future we switch from the whole banner being a link to a button, this can be removed
      if (!newLocation) {
        return;
      }
      if (newLocation.includes("http")) {
        window.open(newLocation, "_blank");
      } else {
        window.open("http://" + newLocation, "_blank");
      }
    },
    navigateTo(newLocation) {
      window.location = newLocation.includes("http")
        ? newLocation
        : "http://" + newLocation;
    },
    dial(phone_number) {
      window.location = "tel:" + phone_number;
    },
    sendMail(email) {
      window.open(
        "mailto:" +
          email +
          "?subject=Request For Information About " +
          this.property.property_name,
        "_blank"
      );
    },

    getContrastingTextColor(color) {
      if (!color) return "#202124";
      const c = color.replace("#", "");
      const rgb = parseInt(c, 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = rgb & 0xff;
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? "#202124" : "#FDFDFD";
    },

    isColorDarkEnough(color) {
      if (!color) return false;
      const c = color.replace("#", "");
      const rgb = parseInt(c, 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = rgb & 0xff;
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness <= 128;
    },
    getOutlinedButtonStyle(color, outlined) {
      // Only apply for outlined buttons
      if (!outlined) {
        return { color: this.getContrastingTextColor(color) };
      }
      if (this.isColorDarkEnough(color)) {
        return {
          color: color,
          borderColor: color
        };
      } else {
        return {
          color: "#000000",
          borderColor: "#000000"
        };
      }
    },
    getGalleryAlt(galleryImage) {
      if (galleryImage.alt && galleryImage.alt.trim() !== "") {
        return galleryImage.alt.trim();
      }
      if (galleryImage.caption && galleryImage.caption.trim() !== "") {
        return galleryImage.caption.trim();
      }
      if (galleryImage.title && galleryImage.title.trim() !== "") {
        const title = galleryImage.title.trim().toLowerCase();
        if (!title.includes("screenshot") && !title.includes("img")) {
          return galleryImage.title.trim();
        }
      }
      return `${this.property.property_name} gallery image`;
    }
  },
  mounted() {
    const accent = this.primaryColor;

    this.propertyPrimaryStyle.backgroundColor = accent;
    this.propertyPrimaryStyle.borderColor = accent;
    this.propertyPrimaryStyle.color = this.getContrastingTextColor(accent);

    // If URL includes a floorplan param, auto-scroll to trigger lazy load.
    const params = new URLSearchParams(window.location.search);
    if (params.get("floorplan")) {
      // Delay a tick so Vue finishes rendering initial page structure
      this.$nextTick(() => {
        // Scroll to #floorplans — Vuetify handles smooth scroll
        if (document.getElementById("floorplans")) {
          this.$vuetify.goTo("#floorplans", {
            duration: 300,
            easing: "easeInOutQuad",
            offset: 0
          });
        }
      });
    }
  },
  components: {
    floorplanSearch: () => import("@shared/components/floorplan-search.vue"),
    propertyCard: () => import("@shared/components/property-card.vue")
  }
};
</script>

<style scoped>
.rentpress-shortcode-single-property-wrapper .pre-formatted {
  white-space: pre-wrap !important;
}

.v-banner,
.v-banner__wrapper {
  border: none !important;
}

.rentpress-single-property-specials-banner .v-banner__wrapper {
  padding: 0 !important;
}

.rentpress-property-special-banner {
  padding: 0.7em;
  font-weight: 500;
  color: inherit;
}

.special-banner-content {
  max-width: 1475px;
  margin: auto;
}

@media (max-width: 960px) {
  .special-banner-content {
    padding: 10px;
  }
}

.property-special-icon {
  flex-shrink: 0;
  font-size: 1.2em;
  line-height: 1;
  margin: -0.3em 0 0 0; /* nudge icon slightly upwards */
}

.special-text-wrapper {
  display: inline;
  margin: 0;
}

.special-text-wrapper strong {
  margin: 0;
}

.hero-image-col {
  height: 400px; /* set height for medium screens */
}

@media (min-width: 960px) {
  .hero-image-col {
    height: 600px; /* large screens */
  }
}

.rentpress-single-property-hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* ensures full coverage */
}

.rentpress-single-property-hero-contact-links {
  column-gap: 0rem;
}

.rentpress-property-card-container {
  display: flex;
  justify-content: center;
}

.rentpress-shortcode-single-property-wrapper {
  overflow: hidden;
}

.rentpress-single-property-subnav {
  position: relative;
}

@media (max-width: 959px) {
  .rentpress-single-property-subnav {
    margin-top: 1em;
  }
}

.rentpress-single-property-hero-info {
  margin: auto;
}

.rentpress-shortcode-single-property-wrapper #property_amenities,
.rentpress-shortcode-single-property-wrapper #property_features {
  columns: 3;
  text-indent: -1.7rem;
  padding-left: 1.7rem;
  column-gap: 2.5rem;
}
#property_amenities > div,
#property_features > div {
  line-height: 1;
}

.rentpress-office-hours-list {
  text-indent: -1.7rem;
  padding-left: 1.7rem;
  list-style-type: none;
}
.rentpress-shortcode-single-property-page-row {
  margin: auto;
  border: none;
}

@media only screen and (min-width: 1200px) {
  .rentpress-shortcode-single-property-page-row {
    max-width: 1200px !important;
  }
}
@media only screen and (max-width: 1200px) {
  .rentpress-shortcode-single-property-page-row {
    max-width: 1000px !important;
  }
}

@media only screen and (max-width: 1200px) {
  .rentpress-shortcode-single-property-wrapper #property_amenities,
  .rentpress-shortcode-single-property-wrapper #property_features {
    columns: 2;
  }
}

@media only screen and (max-width: 600px) {
  .rentpress-shortcode-single-property-wrapper #property_amenities,
  .rentpress-shortcode-single-property-wrapper #property_features {
    columns: 1;
    column-gap: 0px;
  }
  .rentpress-single-property-info-row {
    padding: 3%;
  }
}

/* Button hover styles with darkening effect */
.v-btn.rentpress-application-link-section-url-tour-button:hover,
.v-btn.rentpress-single-property-location-button:hover,
.v-btn.rentpress-gallery-close-button:hover {
  background-color: v-bind("primaryColor") !important;
  filter: brightness(85%) !important;
}

/* Form close button uses CSS custom property set via inline styles */
.v-btn.rentpress-form-close-button:hover {
  background-color: var(--primary-color) !important;
  filter: brightness(85%) !important;
}

/* Keep close buttons circular on hover */
.v-btn.rentpress-form-close-button:hover,
.v-btn.rentpress-gallery-close-button:hover {
  border-radius: 50% !important;
}

@media (max-width: 599px) {
  .related-property-card {
    max-width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (min-width: 960px) {
  .rentpress-single-property-location-romance-copy {
    max-height: 18rem;
    -webkit-mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
    mask-image: linear-gradient(to bottom, black 80%, transparent 100%);
    overflow-y: scroll;
  }
}
</style>
